const envFile = require('../../env')
const env = envFile.env[process.env.BENV || 'prod']

export const checkIsKnechtHome = (page) => 
    page?.pageId?.value === '2548' && env.homepage_destination === 'knecht'